import i18n from 'modules/core/lib/i18n'

import { getRestDayCountCopy, getShiftCountCopy } from 'modules/shift_management/lib/getDescription'
import getTransactionType, {
  TransactionTranslation,
} from 'modules/shift_management/lib/getTransactionType'

const getDeleteModalTranslations = (shiftsCount: number, restDaysCount: number) => {
  const transactionType = getTransactionType(shiftsCount, restDaysCount)

  const and = i18n.t('shift_management.add_shift.and')

  const titleForBoth = `${i18n.t('shift_management.actions.delete_shift')} ${and} ${i18n
    .t('shift_management.sidepanel.rest_days')
    .toLowerCase()}`

  const title: TransactionTranslation = {
    shifts: i18n.t('shift_management.delete_shifts'),
    'rest-days': i18n.t('shift_management.actions.delete_rest_day'),
    both: titleForBoth,
  }

  const button: TransactionTranslation = {
    shifts: i18n.t('shift_management.delete_shifts'),
    'rest-days': i18n.t('shift_management.actions.delete_rest_day'),
    both: i18n.t('shift_management.actions.delete'),
  }

  const shiftsCounter = getShiftCountCopy(shiftsCount)
  const restDaysCounter = getRestDayCountCopy(restDaysCount)

  const shiftsString = `${shiftsCount} ${shiftsCounter}`
  const restDaysString = `${restDaysCount} ${restDaysCounter}`
  const bothString = `${shiftsString} ${and} ${restDaysString}`

  const body: TransactionTranslation = {
    shifts: shiftsString,
    'rest-days': restDaysString,
    both: bothString,
  }

  return {
    title: title[transactionType],
    button: button[transactionType],
    body: body[transactionType],
  }
}

export default getDeleteModalTranslations
